import { ICompanyAnsweredQuestion } from '../../../common';
import { StyledHistoryContainer } from './ViewAnswerHistory.styles';
import ViewAnswerHistoryItem from './ViewAnswerHistoryItem';

interface Props {
    questionsWithAnswers: Array<ICompanyAnsweredQuestion>;
    onEdit: (answer: ICompanyAnsweredQuestion) => void;
}

const ViewAnswerHistory = ({ questionsWithAnswers, onEdit }: Props) => {
    return (
        <StyledHistoryContainer>
            {questionsWithAnswers.map((questionWithAnswer) => (
                <ViewAnswerHistoryItem
                    key={questionWithAnswer.id}
                    questionWithAnswer={questionWithAnswer}
                    onEdit={() => onEdit(questionWithAnswer)}
                />
            ))}
        </StyledHistoryContainer>
    );
};

export default ViewAnswerHistory;
